import React, {useState, useEffect} from 'react'
import './App.css';
import Header from './Header';
import HomeRosa from './HomeRosa';
import Footer from './Footer';
// import AmministrazioneCantina from './AmministrazioneCantina';
// import GestioneCredenziali from './GestioneCredenziali';
// import HomeInizialeMtv from './HomeInizialeMtv';
// import ListaCantine from './ListaCantine';
// import Ricerca from './Ricerca';
// import RicercaData from './RicercaData';
// import LoginMTV from './LoginMTV';
// import Cantina from './Cantina';
// import Evento from './Evento';

import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
  Input,
  InputGroup,
  InputLeftAddon,
  Stack,
  useToast,
  Text,
} from "@chakra-ui/react"


import { apriModaleLogin, apriModaleLogout, apriModaleRecuperPassword } from "./Atoms";
import { utenteAtom } from "./Atoms";
import { useAtom } from "jotai";

import {
  Switch,
  Route,
  Link,
  NavLink
} from "react-router-dom";

import { useHistory } from "react-router-dom";
import md5 from "md5"

import axios from 'axios'



function App() {

  // const { isOpen, onOpen, onClose } = useDisclosure();
  // const [apriModLogin, setApriModLogin] = useAtom(apriModaleLogin);
  // const [apriModLogout, setApriModLogout] = useAtom(apriModaleLogout);
  // const [apriModRecuperaPassword, setApriModRecuperaPassword] = useAtom(apriModaleRecuperPassword);
  // const [utente, setUtente] = useAtom(utenteAtom);
  // const [username, setUsername] = useState("")
  // const [password, setPassword] = useState("")

  // const toast = useToast();

  // const handleChangeUsername = (event) => setUsername(event.target.value)
  // const handleChangePassword = (event) => setPassword(event.target.value)

  let history = useHistory();
    history.listen((location, action) => {
      window.scrollTo(0, 0)
  })

  useEffect(() => {
    //check versione app
    axios.get('https://www.recode.digital/una-rosa-per-maria/server_rosa/public/versioni')
    .then(function (response) {
        console.log(response.data)

        if(localStorage.getItem("versione_app") !== null && localStorage.getItem("versione_app") !== response.data[0].versione){
          localStorage.setItem("versione_app", response.data[0].versione);
          window.location.reload();
        }else
        if(localStorage.getItem("versione_app") === null){
          localStorage.setItem("versione_app", response.data[0].versione);
        }
        
    });
    
  }, [])



  // const login = (email, password) => {

  //   let noEmpty = true;
  //   let data = new FormData();

  //   console.log(md5(password));

  //   if(email==="" || password ===""){
  //     noEmpty = false;
  //   }
  //   else{
  //     data.append('email', email);
  //     data.append('password', md5(password));
  //   }

  //   // let noEmpty = true;
  //   // for (var value of data.values()) {
  //   //     if (value === ''){
  //   //         noEmpty = false;
  //   //     }
  //   // }

  //   if(noEmpty){
  //       axios.post('https://www.eventimtvmarche.it/servermtv/public/login', data)
  //       .then(function (response) {
  //           console.log(response.data);
  //           if(response.data.length = 1){
  //             toast({
  //               title: "Login Effettuato",
  //               description: "Hai effettuato correttamente il login",
  //               status: "success",
  //               duration: 3000,
  //               isClosable: true,
  //             })

  //             setUtente(response.data[0]);
  //             //localStorage.setItem('utente', JSON.stringify(response.data[0]));
                
  //           }
  //       })
  //       .catch(function (error) {
  //           console.log(error);
  //           toast({
  //               title: "Errore",
  //               description: "Username o password non corrispondono. Riprova.",
  //               status: "error",
  //               duration: 3000,
  //               isClosable: true,
  //           })
  //       });
  //   }
  //   else{
  //       toast({
  //           title: "Dati mancanti",
  //           description: "Devi aggiungere tutti i dati prima di poter effettuare il login.",
  //           status: "info",
  //           duration: 3000,
  //           isClosable: true,
  //       })

  //   }
  // }

  // const logout = () => {
  //   setUtente({});
  //   setApriModLogout(false);
  //   //localStorage.setItem('utente', '');
  //   toast({
  //     title: "Logout effettuato",
  //     description: "Sei uscito dal tuo account",
  //     duration: 3500,
  //     isClosable: true,
  //   })
  // }

  // const recuperaPassword = () => {
  //   axios.get('https://biomalavoltamassignano.it/malavolta_server/', {
  //       params: {
  //           param: 'recuperaPassword',
  //           mail: username,
  //       }
  //   })
  //   .then(function (response) {
  //       console.log(typeof(response.data))
  //       console.log(response.data)
  //       if(response.data === "ok"){
  //           setApriModRecuperaPassword(false);
  //           toast({
  //             title: "Mail di recupero inviata con successo!",
  //             description: "Controlla la tua casella di posta per recuperare la tua password!",
  //             status: "success",
  //             duration: 9000,
  //             isClosable: true,
  //           })
  //       }
  //   });
  // }

  return (
    <>

      <div className="App" >
        <Header/>
        <Route
          exact
          path='/'
          render={() => (<HomeRosa />)}/>
      </div>
      <Footer />

    </>
      
  );
}

export default App;
